import React, { useState, useEffect } from 'react';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { UserAuthContext } from '../context/AuthContext';

const LoadingModalPage = ({
  loading,
  modal,
  title,
  textInside,
  setInfoSubmit,
  setSavedForm,
  exitAfter,
}) => {
  const { logout } = UserAuthContext();
  const [showLoading, setShowLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (loading) {
      setShowLoading(true);
    }
    if (modal) {
      setShowModal(true);
    }
  }, [loading, modal]);

  const exitButton = async (exitNow) => {
    if (exitNow) {
      try {
        await logout();
        window.location.href = 'https://www.meritsaccounting.ca/';
        console.log('You are log out');
      } catch (e) {
        console.log(e.message);
      }
    }
  };

  return (
    <>
      {showLoading && (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z[500] outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-3xl">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full  outline-none focus:outline-none">
                <AiOutlineLoading3Quarters
                  size={90}
                  className="text-blue-300 animate-spin"
                />
              </div>
            </div>
          </div>
          <div className="opacity-75 fixed inset-0 z-40 bg-black"></div>
        </>
      )}
      {showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-[500] outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-3xl">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-3xl font-semibold">{title}</h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => {
                      setShowModal(false);
                      setInfoSubmit(false);
                      setSavedForm(false);
                    }}
                  >
                    <span className="bg-transparent text-">×</span>
                  </button>
                </div>
                <div className="relative p-6 flex-auto">
                  <div className="my-4 text-slate-500 text-lg leading-relaxed w-screen max-w-2xl whitespace-pre-wrap">
                    {textInside}
                  </div>
                </div>
                {/*footer*/}
                <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                  <button
                    className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => {
                      setShowModal(false);
                      setInfoSubmit(false);
                      setSavedForm(false);
                      exitButton(exitAfter);
                    }}
                  >
                    {exitAfter === undefined ? 'Close' : 'Exit'}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default LoadingModalPage;
